import { render, staticRenderFns } from "./TheOwnersUpdate.vue?vue&type=template&id=45dc89c1"
import script from "./TheOwnersUpdate.vue?vue&type=script&lang=js"
export * from "./TheOwnersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports